"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //lodash
//styles
var ElementResizeListenerComponent = /*#__PURE__*/function (_Component) {
  function ElementResizeListenerComponent() {
    var _this;
    _classCallCheck(this, ElementResizeListenerComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ElementResizeListenerComponent, [].concat(args));
    _defineProperty(_this, "iFrameElement", null);
    _defineProperty(_this, "propagateResize", function () {
      if (!_this.iFrameElement) {
        return;
      }
      (0, _invoke["default"])(_this.props, 'onResize', {
        width: _this.iFrameElement.offsetWidth,
        height: _this.iFrameElement.offsetHeight
      });
    });
    _defineProperty(_this, "setIFrameElement", function (iFrameElement) {
      _this.iFrameElement = iFrameElement;
    });
    return _this;
  }
  _inherits(ElementResizeListenerComponent, _Component);
  return _createClass(ElementResizeListenerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.iFrameElement) {
        return;
      }
      this.iFrameElement.contentWindow.addEventListener('resize', this.propagateResize);
      window.requestAnimationFrame(this.propagateResize);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var forwardedProps = (0, _omit["default"])(this.props, 'onResize');
      return /*#__PURE__*/_react["default"].createElement(_styles.ElementResizeListener, forwardedProps, /*#__PURE__*/_react["default"].createElement(_styles.HiddenIFrame, {
        ref: this.setIFrameElement,
        src: "about:blank"
      }), children);
    }
  }]);
}(_react.Component);
_defineProperty(ElementResizeListenerComponent, "defaultProps", {
  position: 'relative'
});
_defineProperty(ElementResizeListenerComponent, "propTypes", {
  onResize: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(['absolute', 'relative', 'sticky'])
});
var _default = exports["default"] = ElementResizeListenerComponent;
//# sourceMappingURL=index.js.map